import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';
import { POPUP_WIDTH } from './const';

export const useStyles = makeStyles(
  (theme) => ({
    paper: {
      width: POPUP_WIDTH,
      height: 442,

      // for 13" macbook
      '@media screen and (max-height: 800px)': {
        maxHeight: 'calc(100% - 20px)',
      },
    },
    dialogTitle: {
      padding: theme.spacing(5, 3.75, 0),
    },
    title: {
      marginBottom: theme.spacing(0.75),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
      fontWeight: theme.typography.fontWeightMedium,
    },
    description: {
      color: COLORS.neutral.mediumGray,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(19),
      letterSpacing: 0,
    },
    dialogContent: {
      padding: theme.spacing(0, 3.75),
      overflow: 'visible',
      height: 220,
    },
    unsetHeight: {
      height: 'unset',
    },
    dialogActions: {
      borderTop: `1px solid ${theme.palette.dividerGray}`,
      margin: 0,
      marginTop: theme.spacing(3.5),
      padding: theme.spacing(2, 3.75),
    },
    buttonAction: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
    },
  }),
  {
    name: 'ScoringMethodPopup',
  }
);
